<form [formGroup]="searchStudentForm" (submit)="search(false)"><!-- -->
	<mat-card appearance="outlined">

		<mat-card-header>
			<mat-card-title class="title-row">
				<div class="title-text">Search Children</div>

				<help-text-btn class="align-help-text-btn" [helpTextId]="'SearchChildren_Overview'"></help-text-btn>

				<span class="instructionMsg" *ngIf="!hasTwoFields()">
					{{ instructionMsgText }}
				</span>
			</mat-card-title>
		</mat-card-header>
		<mat-card-content>
			<div class="row">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
					<mat-card appearance="outlined">
						<mat-card-header>
							<mat-card-title>Basic Child Search Information</mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<div class="row">
								<mat-form-field class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<mat-label>Last Name</mat-label>
									<input matInput type="string" placeholder="Last Name" formControlName="lastName"
										appOnlyLetters />
								</mat-form-field>

								<mat-form-field class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<mat-label>First Name</mat-label>
									<input matInput type="string" placeholder="First Name" formControlName="firstName"
										appOnlyLetters />
								</mat-form-field>
							</div>
							<div class="row">
								<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<mat-label>Middle Name</mat-label>
									<input matInput type="string" placeholder="Middle Name" formControlName="middleName"
										appOnlyLetters />
								</mat-form-field>
								<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<mat-label>2nd Last Name</mat-label>
									<input matInput type="string" placeholder="Second Last Name"
										formControlName="secondLastName" appOnlyLetters />
								</mat-form-field>
							</div>
							<div class="row">
								<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<mat-label>Legal Mother's First Name</mat-label>
									<input matInput type="string" placeholder="Legal Mother's First Name"
										formControlName="legalMotherFirstName" appOnlyLetters />
								</mat-form-field>
								<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<mat-label>Birth City</mat-label>
									<input matInput type="string" placeholder="Birth City" formControlName="birthCity"
										appOnlyLetters />
								</mat-form-field>
							</div>

							<div class="row">
								<mat-form-field color="primary" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<mat-label>Date of Birth</mat-label>
									<mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
										<input matStartDate formControlName="startDate" placeholder="Start date"
											style="font-size:14px;">
										<input matEndDate formControlName="endDate" placeholder="End date"
											style="font-size:14px;">
									</mat-date-range-input>
									<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
									<mat-date-range-picker #picker 
										[startAt]="startAt" [startView]="'multi-year'">
									</mat-date-range-picker>

								</mat-form-field>


								<region-dropdown-two-way class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
									[isMultiple]="true" [(selectedRegions)]="chosenRegions" [reset]="resetField"
									[disableAutoComplete]="true" [allowAllRegions]="true" #appRegionCode
									(selectedRegionsChange)="this.disableButton = validateFields()">
								</region-dropdown-two-way>
							</div>

							<div class="row">
							</div>
							<div class="row">

								<mat-checkbox [color]="'primary'" formControlName="includeHardTerminations">Include Hard
									Terminations (Graduated/HSE, Over
									Age, Deceased)</mat-checkbox>
							</div>

						</mat-card-content>

					</mat-card>
				</div>

				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
					<!--Advanced Search Options-->
					<mat-card appearance="outlined">
						<mat-card-header>
							<mat-card-title>Advanced Search Options</mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<div class="row">
								<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
									<mat-label>MSD Number</mat-label>
									<input matInput type="string" placeholder="MSD Number" formControlName="msd"
										[numericOnly]="11" />
								</mat-form-field>

								<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
									<mat-label>COE Number</mat-label>
									<input matInput type="string" placeholder="COE Number" formControlName="coe"
										[maxLength]="7" />
								</mat-form-field>
								<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
									<mat-label>MSIX</mat-label>
									<input matInput type="string" placeholder="MSIX" formControlName="msix"
										[numericOnly]="100" />
								</mat-form-field>
							</div>
							<div class="row">
								<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<mat-label>SSID</mat-label>
									<input matInput type="string" placeholder="SSID" formControlName="ssid"
										[numericOnly]="10" />
								</mat-form-field>
								<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
									<mat-label>Local SIS ID</mat-label>
									<input matInput type="string" placeholder="Local SIS ID"
										formControlName="localSISID" [numericOnly]="100" />
								</mat-form-field>
							</div>

							<div>
								<mat-accordion>
									<!-- Location -->
									<mat-expansion-panel hideToggle="false" [expanded]="locationExpanded">
										<mat-expansion-panel-header>
											<mat-panel-title>
												Location
											</mat-panel-title>
										</mat-expansion-panel-header>

										<county-dropdown-two-way [(selectedCounties)]="chosenCounties"
											[reset]="resetField" [required]="false" #appCountyCode
											[regions]="chosenRegions" [disableAutoComplete]="true"
											(selectedCountiesChange)="this.disableButton = validateFields()">
										</county-dropdown-two-way>

										<district-dropdown-two-way [(selectedSchoolDistricts)]="chosenSchoolDistricts"
											[reset]="resetField" [required]="false" #appSchoolDistrictCode
											[regions]="chosenRegions" [counties]="chosenCounties"
											[disableAutoComplete]="true"
											(selectedSchoolDistrictsChange)="this.disableButton = validateFields()">
										</district-dropdown-two-way>

										<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools"
											[reset]="resetField" #appSchoolsCode [regions]="chosenRegions"
											[counties]="chosenCounties" [schoolDistricts]="chosenSchoolDistricts"
											[disableAutoComplete]="true"
											(selectedSchoolsChange)="this.disableButton = validateFields()">
										</school-dropdown-two-way>
									</mat-expansion-panel>
								</mat-accordion>
							</div>


							<div>
								<mat-accordion>
									<!--Family-->
									<mat-expansion-panel hideToggle="false" [expanded]="familyExpanded">
										<mat-expansion-panel-header>
											<mat-panel-title>
												Family
											</mat-panel-title>
										</mat-expansion-panel-header>

										<div class="row">
											<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
												<mat-label>Legal Parent/Guardian 2 First Name (Mother)</mat-label>
												<input matInput type="string"
													placeholder="Legal Parent/Guardian 2 First Name (Mother)"
													formControlName="motherFirstName" appOnlyLetters />
											</mat-form-field>

											<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
												<mat-label>Legal Parent/Guardian 2 Last Name</mat-label>
												<input matInput type="string"
													placeholder="Legal Parent/Guardian 2 Last Name"
													formControlName="motherLastName" appOnlyLetters />
											</mat-form-field>
										</div>
										<div class="row">
											<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
												<mat-label>Legal Parent/Guardian 1 First Name (Father)</mat-label>
												<input matInput type="string"
													placeholder="Legal Parent/Guardian 1 First Name (Father)"
													formControlName="fatherFirstName" appOnlyLetters />
											</mat-form-field>
											<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
												<mat-label>Legal Parent/Guardian 1 Last Name</mat-label>
												<input matInput type="string"
													placeholder="Legal Parent/Guardian 1 Last Name"
													formControlName="fatherLastName" appOnlyLetters />
											</mat-form-field>
										</div>
									</mat-expansion-panel>
								</mat-accordion>
							</div>
							<div>
								<mat-accordion>
									<!--Personal Information-->
									<mat-expansion-panel hideToggle="false" [expanded]="personalExpanded">
										<mat-expansion-panel-header>
											<mat-panel-title>
												Personal Information
											</mat-panel-title>
										</mat-expansion-panel-header>

										<div class="row">
											<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
												<mat-label>Birth State</mat-label>
												<input matInput type="string" placeholder="Birth State"
													formControlName="birthState" appOnlyLetters />
											</mat-form-field>

											<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
												<mat-label>Birth Country</mat-label>
												<input matInput type="string" placeholder="Birth Country"
													formControlName="birthCountry" appOnlyLetters />
											</mat-form-field>
											<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
												<mat-select formControlName="gender" placeholder="Select the Gender">
													<mat-option value="">Gender</mat-option>
													<mat-option value="M">Male</mat-option>
													<mat-option value="F">Female</mat-option>
													<mat-option value="O">Other</mat-option>
													<mat-option value="B">[Blank]</mat-option>

												</mat-select>
											</mat-form-field>
										</div>


									</mat-expansion-panel>
								</mat-accordion>
							</div>
						</mat-card-content>
					</mat-card>

				</div>
			</div>
		</mat-card-content>
		<mat-card-actions>
			<!-- 				[color]="msg.MSG?.length!>=1 ? 'warn' :  'primary'"-->
			<button type="submit" style="height:38px;position:relative;margin-top:2px;"
				(onSearchErrorEvent)="catchSearchError($event)" (click)="search(false);" mat-raised-button
				[color]="isLoadingResults ? 'basic' : (msg.MSG?.length! >= 1 ? 'warn' :  'primary')"
				[disabled]="!hasTwoFields() || isLoadingResults">
				<mat-icon *ngIf="isLoadingResults">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>&nbsp;&nbsp;&nbsp;
			<button type="button" mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>


		</mat-card-actions>
		<div>
			<!-- *ngIf="((!validateBasicFields() && !this.g_bAdvancedFieldsFilled) && !this.validateFields()) || errorMsgText"-->
			<textarea class="errorMsg" id="txtErrorMsg" disabled readonly="true" rows="2">{{ errorMsgText }}</textarea>
		</div>

	</mat-card>

</form>


<div style="margin-top: 15px;" class="margin-top-sm table-responsive" [hidden]="results.length === 0">
	<h2>
		Search Results - {{tableDataSources[0]?.filteredData?.length === studentLength ? studentLength :
		(tableDataSources[0]?.filteredData?.length + '/' + studentLength)}} Child(ren)
		<button class="pull-right" mat-raised-button color="primary" (click)="shoppingCartAddAll()" mat-button>Select
			All Children</button>
	</h2>
	<hr />

	<div class="row">
		<mat-form-field>
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
				(ngModelChangeDebounced)="setFilter();" />
		</mat-form-field>
	</div>


	<mat-table [dataSource]="tableDataSources[0]" matSort (matSortChange)="announceSortChange($event)">
		<ng-container matColumnDef="ACTION" style="min-width: 20px">
			<mat-header-cell *matHeaderCellDef>
				Action
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div>
					<button mat-icon-button color="primary" (click)="shoppingCartAdd(element)">
						<mat-icon [matTooltip]="'Add Child'" [matTooltipPosition]="'above'">add</mat-icon>
					</button>
				</div>
				<edit-child-modal-btn [searchStudent]="element" [studentId]="element.ID" [type]="'icon'"
					[icon]="'visibility'">
				</edit-child-modal-btn>

			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="REGIONS[0].CODE">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				Region
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<ng-container *ngIf="element.REGIONS">
					<button style="text-align:left;"
						*ngIf="element.REGIONS?.length<=1 && element.REGIONS[0]?.CODE != null && element.REGIONS[0].CODE != 0"
						mat-button>{{element.REGIONS[0].CODE}}</button>

					<button style="text-align:left;"
						*ngIf="element.REGIONS?.length>1 && element.REGIONS[0]?.CODE != null && element.REGIONS[0].CODE != 0"
						mat-button #tooltip="matTooltip" [matTooltip]="listofRegionCode(element.REGIONS)"
						matTooltipPosition="right">
						{{element.REGIONS[0].CODE}} ...
					</button>
				</ng-container>
				<span *ngIf="!element.REGIONS || element.REGIONS.length === 0">
					No Region
				</span>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="PERSON.LAST_NAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				Last Name
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.PERSON.LAST_NAME}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="SECOND_LAST_NAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				2nd Last Name
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.SECOND_LAST_NAME }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="PERSON.FIRST_NAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				First Name
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.PERSON.FIRST_NAME }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="PERSON.MIDDLE_INITIAL">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				Middle Name
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element?.PERSON.MIDDLE_INITIAL}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="DOB">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				DOB (Age)
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element?.DOB | simpleDate}} {{element.DOB | age }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="SEX">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				Gender
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element?.SEX}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="LEGAL_MOTHERS[0].FIRST_NAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				LM Name
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.LEGAL_MOTHERS?.length>0 ? element.LEGAL_MOTHERS[0].FIRST_NAME : '' }}
				{{element.LEGAL_MOTHERS?.length>0 ? element.LEGAL_MOTHERS[0].LAST_NAME : ''}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="LEGAL_FATHERS[0].FIRST_NAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				LF Name
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.LEGAL_FATHERS?.length>0 ? element.LEGAL_FATHERS[0]?.FIRST_NAME : '' }}
				{{element.LEGAL_FATHERS?.length>0 ? element.LEGAL_FATHERS[0]?.LAST_NAME : '' }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="MSD_NUMBER">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				MSD Number
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.MSD_NUMBER}}
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

		<mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'terminatedRow': 
				row.STUDENT_TERMINATION_STATUSES?.length > 0 && 
				row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}" [matTooltip]="
				row.STUDENT_TERMINATION_STATUSES && 
				row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE" [matTooltipPosition]="'above'"
			[matTooltipDisabled]="
				row.STUDENT_TERMINATION_STATUSES?.length === 0 || 
				(row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
			[matTooltipClass]="'terminatedTooltip'">
		</mat-row>

	</mat-table>

	<mat-paginator #searchPaginator
		[pageSizeOptions]="[5, 10, 20, (tableDataSources ? tableDataSources[0] ? tableDataSources[0].data.length > 100 ? tableDataSources[0].data.length : 100 : 100 : 100)]"
		showFirstLastButtons aria-label="Select page of periodic elements"
		[hidden]="tableDataSources[0]?.filteredData?.length === 0">
	</mat-paginator>


	<div [hidden]="shoppingCart.length === 0 || hideShoppingCart" class="margin-top-md">
		<h2>
			Chosen Children - {{shoppingCartTableDataSources[0]?.filteredData?.length === shoppingCartLength ?
			shoppingCartLength :
			(shoppingCartTableDataSources[0]?.filteredData?.length + '/' + shoppingCartLength)}} Child(ren)
			<button class="pull-right" mat-raised-button color="warn" (click)="shoppingCartRemoveAll()" mat-button>Clear
				Chosen Children</button>
		</h2>
		<hr />

		<div class="row">
			<mat-form-field>
				<mat-label>
					Filter
				</mat-label>
				<input matInput id="filter" name="filter" type="string" [(ngModel)]="shoppingCartFilter"
					(ngModelChangeDebounced)="setShoppingCartFilter();" />
			</mat-form-field>
		</div>

		<div class="table-responsive">
			<mat-table [dataSource]="shoppingCartTableDataSources[0]" class="mat-elevation-z1" matSort
				(matSortChange)="announceSortChange($event)">

				<ng-container matColumnDef="ACTION" style="min-width: 20px">
					<mat-header-cell *matHeaderCellDef>
						Action
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<!-- <button mat-icon-button color="primary" (click)="view(element)">
							<mat-icon>visibility</mat-icon>
						</button> -->
						<div>
							<button mat-icon-button color="primary" (click)="shoppingCartRemove(element)">
								<mat-icon [matTooltip]="'Remove Child'" [matTooltipPosition]="'above'">remove</mat-icon>
							</button>
						</div>

						<edit-child-modal-btn [searchStudent]="element" [studentId]="element.ID" [type]="'icon'"
							[icon]="'visibility'">
						</edit-child-modal-btn>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="REGIONS[0].CODE">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Region
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<ng-container *ngIf="element.REGIONS">
							<button style="text-align:left;"
								*ngIf="element.REGIONS.length<=1 && element.REGIONS[0]?.CODE != null && element.REGIONS[0].CODE != 0"
								mat-button>{{element.REGIONS[0].CODE}}</button>

							<button style="text-align:left;"
								*ngIf="element.REGIONS.length>1 && element.REGIONS[0]?.CODE != null && element.REGIONS[0].CODE != 0"
								mat-button #tooltip="matTooltip" [matTooltip]="listofRegionCode(element.REGIONS)"
								matTooltipPosition="right">
								{{element.REGIONS[0].CODE}} ...
							</button>
						</ng-container>
						<span *ngIf="!element.REGIONS || element.REGIONS.length === 0">
							No Region
						</span>
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="PERSON.LAST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Last Name
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.PERSON.LAST_NAME}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="SECOND_LAST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						2nd Last Name
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.SECOND_LAST_NAME }}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="PERSON.FIRST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						First Name
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.PERSON.FIRST_NAME }}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="PERSON.MIDDLE_INITIAL">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Middle Name
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element?.PERSON.MIDDLE_INITIAL}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="DOB">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						DOB (Age)
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element?.DOB | simpleDate}} {{element.DOB | age }}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="SEX">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Gender
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element?.SEX}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="LEGAL_MOTHERS[0].FIRST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						LM Name
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.LEGAL_MOTHERS?.length>0 ? element.LEGAL_MOTHERS[0].FIRST_NAME : '' }}
						{{element.LEGAL_MOTHERS?.length>0 ? element.LEGAL_MOTHERS[0].LAST_NAME : ''}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="LEGAL_FATHERS[0].FIRST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						LF Name
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.LEGAL_FATHERS?.length>0 ? element.LEGAL_FATHERS[0]?.FIRST_NAME : '' }}
						{{element.LEGAL_FATHERS?.length>0 ? element.LEGAL_FATHERS[0]?.LAST_NAME : '' }}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="MSD_NUMBER">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						MSD Number
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{element.MSD_NUMBER}}
					</mat-cell>
				</ng-container>


				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"
					[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
					[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
					[matTooltipPosition]="'above'"
					[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
					[matTooltipClass]="'terminatedTooltip'"></mat-row>
			</mat-table>
		</div>
		<mat-paginator #paginators
			[pageSizeOptions]="[5, 10, 20, (shoppingCartTableDataSources ? shoppingCartTableDataSources[0] ? shoppingCartTableDataSources[0].data.length > 100 ? shoppingCartTableDataSources[0].data.length : 100 : 100 : 100)]"
			showFirstLastButtons aria-label="Select page of periodic elements"
			[hidden]="shoppingCartTableDataSources[0]?.filteredData?.length === 0">
		</mat-paginator>
	</div>
</div>